import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { format } from "date-fns";

export interface DoctorAppointment {
  appointment_id: string;
  clinic_id: string;
  clinic_name: string;
  patient_name: string;
  start_time: string;
  end_time: string;
  status: string;
  duration_minutes: number;
}

export const useDoctorDaySchedule = (doctorId?: string, date?: Date) => {
  return useQuery({
    queryKey: ["doctor-day-schedule", doctorId, date?.toISOString()],
    queryFn: async () => {
      if (!doctorId || !date) return [];

      const { data, error } = await supabase.rpc("get_doctor_day_schedule", {
        p_doctor_id: doctorId,
        p_date: format(date, "yyyy-MM-dd"),
      });

      if (error) throw error;
      return (data || []) as DoctorAppointment[];
    },
    enabled: !!doctorId && !!date,
  });
};
